import {BaseElement, OSkinableInit} from "/@back@/commons/basis.js";
import {IItemUiEnv, installSrcViewFileDrop} from "/@back@/wsp/views/itemMain.js";
import {IReg, REG} from "/@lib@/commons/registry.js";
import {IView} from "/@lib@/commons/views.js";
import {JSX} from "/@lib@/commons/xml/dom.js";
import {DOMSH} from "/@lib@/commons/xml/domsh.js";
import {JWspUriChangeMsg, WSP} from "/@lib@/wsp/wsp.js";
import {SRC} from "/@lib@/wsp/src.js";
import {IAction} from "/@lib@/commons/actions.js";
import {IShortDescCtx} from "/@lib@/wsp/item.js";
import {BarActions, OBarActionsInit} from "/@back@/commons/widgets/bars.js";

/**
 * View d'affichage d'un flux audio.
 *
 * TODO forme d'onde...
 *
 * Config attributes:
 */
export interface OItemAudioInit extends OSkinableInit {
	reg?: IReg<IItemUiEnv>
	transform?: string
}

export interface ItemAudio extends BaseElement {
	initialize(init: OItemAudioInit): this;
}

export class ItemAudio extends BaseElement implements IView {
	reg: IReg<IItemUiEnv>;

	_initialize(init: OItemAudioInit) {
		this.reg = this.findReg(init);
		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this._initAndInstallSkin(this.localName, init);
		installSrcViewFileDrop(this.reg, this);
		const {env} = this.reg;

		const ctx = this.reg.env.srcView;
		const actions = this.reg.mergeLists<IAction<IShortDescCtx>>("actions:wsp:itemAudio", "actions:wsp:binaryStream").filter((a) => a.isInstantiable(ctx));
		if (actions.length > 0) sr.appendChild(
			<BarActions î={{actions, actionContext: ctx, reg: this.reg} as OBarActionsInit<IShortDescCtx>}/>
		);

		const audio = <audio src={this.getStreamUrl(env, init.transform)} controls/>;
		sr.appendChild(audio);

		// Listener sur les changements de la ressource
		env.place.eventsMgr.on("wspUriChange", (msg: JWspUriChangeMsg) => {
			if (SRC.srcRef(env.longDesc) === SRC.srcRef(msg)) {
				audio.src = this.getStreamUrl(env, init.transform)
			}
		});
	}

	getStreamUrl(env: IItemUiEnv, transform: string) {
		return WSP.getStreamStampedUrl(env.wsp, env.itemType.getMainStreamSrcUri(env.longDesc), env.longDesc.srcDt, transform)
	}
}

REG.reg.registerSkin("wsp-item-audio", 1, /* language=CSS */ `
	:host {
		display: flex;
		min-height: 0;
		min-width: 0;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 1px;
	}
`);


customElements.define("wsp-item-audio", ItemAudio);
